export default Backbone.Model.extend({
  initialize: function () {
    this.set("page", this.get("page").image);
  }
});